import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button as AntButton, Modal } from 'antd';

import useAxios from '../../hooks/useAxios';
import { getNoticeCampus } from '../../api/boardNotice.api';
import Loader from '../Loader';
import ErrorResponse from '../ErrorResponse';

interface IProps {
  campusDetailVisible: boolean;
  setCampusDetailVisible: Function;
  getCampusInfo: Function;
  noticeCode: number | undefined;
}

const SelectGroupModal: FC<IProps> = ({
  campusDetailVisible,
  setCampusDetailVisible,
  getCampusInfo,
  noticeCode,
}) => {
  const { t } = useTranslation();
  const { data, isLoading, error, execute } = useAxios<any>();

  useEffect(() => {
    if (noticeCode) {
      execute(getNoticeCampus(noticeCode));
    }
  }, [noticeCode]);

  return (
    <>
      {isLoading ? <Loader /> : null}
      <ErrorResponse error={error} />
      <Modal
        title={t('board.notice.title2')}
        visible={campusDetailVisible}
        onCancel={() => setCampusDetailVisible(false)}
        footer={[
          <div className='comm-btn__area justify-content-center'>
            <AntButton
              key="cancel"
              className='btn-basic gray'
              onClick={() => setCampusDetailVisible(false)}
            >
              {t('common.button.close')}
            </AntButton>
          </div>
        ]}
      >
        <div className='comm-table__area'>
          <table>
            <colgroup>
              <col width="40%" />
              <col width="60%" />
            </colgroup>
            <thead>
              <tr>
                <th>{t('board.notice.column3')}</th>
                <th>{t('common.menu.campus')}</th>
              </tr>
            </thead>
            <tbody>
              {data?.data.map((campusCode: any) => (
                <tr>
                  <td>{getCampusInfo(campusCode, 'region')}</td>
                  <td>{getCampusInfo(campusCode, 'name')}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Modal>
    </>
  );
};

export default SelectGroupModal;
